import axios from 'axios'

export const getRegistryData = async (registryNumber: string) => {
  const response = await axios.get(`/api/v1/ur_dati/${registryNumber}`)

  return response.data
}
